import React from 'react'
import { useFormContext } from 'react-hook-form'
import { mixinInputForm } from 'spa/member/styles/mixin'
import styled from 'styled-components'
import AlertIcon from 'images/alert_icon.svg'


export type Props = {
  name: string;
  rules?: any;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>

const StyledTextAreaBox = styled.textarea<{ hasError?: boolean }>`
  ${mixinInputForm}
  min-height: 140px;
  background-color: ${props => props.hasError ? '#FFEDED' : props.theme.members.colors.white};  color: ${props => props.theme.members.colors.black._100};
  border: 1px solid ${props => props.hasError ? '#D52020' : props.theme.members.colors.silver._70};
  line-height: 1.5;
  padding: .5rem .75rem;
`
const ErrorMessage = styled.span`
  color: #F15252;
  font-size: 0.875rem;
  margin-top: 4px;
  display: block;
  font-weight: 400;
`

export const StyledTextArea: React.FC<Props> = (props: Props) => {
  const { register, formState: { errors } } = useFormContext()
  return(
    <>
      <StyledTextAreaBox hasError={!!errors[props.name]} {...props} {...register(props.name,props.rules)} />
      {errors[props.name] && (
        <ErrorMessage>
          <img className="inline" src={AlertIcon}/>
          {errors[props.name].message}
        </ErrorMessage>
      )}
    </>
  )
}
